app.StandardCartItem = window.StandardCartItem = (function () {

    function StandardCartItem(data) {
        this.originalId = data.oId ? data.oId : null;
        this.actualId = data.aId ? data.aId : null;
        this.eventId = data.eId ? data.eId : null;
        this.eventTitle = data.eTitle ? data.eTitle : null;
        this.resultTitle = data.rTitle ? data.rTitle : null;
        this.coefValue = data.val ? parseFloat(parseFloat(data.val.toString().replace(',', '.')).toFixed(2)) : null;
        this.originalCoefValue = data.originalCoefValue ? parseFloat(data.originalCoefValue.toString().replace(',', '.')) : this.coefValue;
        this.isLive = data.isLive ? data.isLive : false;
        this.currency = data.currency ? data.currency : window.globalAppSettings.currentUser.defaultBalance.currencyCode;
        this.minMoneyValue = data.MinMoneyValue ? data.MinMoneyValue : 0;
        this.maxMoneyValue = data.MaxMoneyValue ? data.MaxMoneyValue : 0;
        this.errors = [];
        this.bet = data.bet ? parseInt(data.bet) : 0;
        this.dom = {};
        this.isSelected = data.isSelected === false ? false : true;
        this.combobox = null;
        this.isSelectedForFreebet = false;

        this.coefIsActive = data.isActive || true;
        this.coefIsOver = data.isOver || false;
        this.eventIsActive = data.eventIsActive || true;
        this.eventIsOver = data.eventIsOver || false;
    }

    StandardCartItem.prototype.draw = function () {
        var self = this;

        this.dom.container = $('[js-node="standard-cart__item-example"]')
            .eq(0)
            .clone()
            .appendTo('[js-node="standard-cart__items"]')
            .removeClass('hidden')
            .removeAttr('js-node');

        this.dom.eventTitle = this.dom.container.find('[js-node="standard-cart__item-title"]');
        this.dom.resultTitle = this.dom.container.find('[js-node="standard-cart__item-market"]');
        this.dom.coefValue = this.dom.container.find('[js-node="standard-cart__item-coef"]');
        this.dom.removeBtn = this.dom.container.find('[js-node="standard-cart__item-remove"]');
        this.dom.maxMoneyValueBtn = this.dom.container.find('[js-node="standard-cart__item-max-money-value-btn"]');
        this.dom.input = this.dom.container.find('[js-node="standard-cart__item-sum-input"]');
        this.dom.inputWrapper = this.dom.container.find('[js-node="standard-cart__item-sum-wrapper"]');
        this.dom.liveIcon = this.dom.container.find('[js-node="standard-cart__live-icon"]');
        this.dom.errorsIcon = this.dom.container.find('[js-node="standard-cart__item-errors"]');
        this.dom.selectInput = this.dom.container.find('[name="cart-item__select-item-checkbox-input"]');
        this.dom.currencySelect = this.dom.container.find('[name="cart-item__currency-select"]');

        this.dom.container.find('[name="cart-item-freebet-radio"]').attr('value', this.originalId);

        if (this.isLive === true) {
            this.dom.liveIcon.removeClass('hidden');
        }

        if (this.isSelected === false) {
            this.dom.selectInput.prop('checked', false);
        }

        var maxBetAmountButtonSettings = globalAppSettings.currentUser.bettingCart['max-bet-amount-button'];
        if (!!!maxBetAmountButtonSettings.IsEnabled) {
            this.setMaxMoneyValueButtonIsDisabled(true, maxBetAmountButtonSettings.Message);
        }

        if ($.fn.niceSelect) {
            self.dom.currencySelect.niceSelect();
        }

        this.updateDom();
        this.bindUI();
        this.initCombobox();
    };

    StandardCartItem.prototype.erase = function () {
        this.dom.container.remove();
    };

    StandardCartItem.prototype.setData = function (data) {
        if (typeof data === 'object') {
            for (var key in data) {
                if (this.hasOwnProperty(key))
                    this[key] = data[key];
            }
        }

        this.updateDom();
    };

    StandardCartItem.prototype.setBet = function (newBet) {
        this.bet = (newBet) ? parseInt(newBet) : 0;
        this.validate();

        BettingCart.calc();
        BettingCart.validate();
    };

    StandardCartItem.prototype.initCombobox = function () {
        var self = this,
            sums = window.globalAppSettings.additionalSumValues;

        if (window.globalAppSettings.additionalSum && sums.length > 0) {
            var cValues = [];

            for (var i = 0; i < sums.length; i++) {
                if (sums[i] > 0) {
                    cValues.push(sums[i]);
                }
            }

            if (cValues.length > 0) {
                self.combobox = new Combobox(cValues, self.dom.input);
            }
        }
    };

    StandardCartItem.prototype.updateDom = function () {
        var self = this;

        self.dom.input.val(self.bet === 0 ? '' : app.numberToString(self.bet));

        self.dom.container
            .attr('data-event-id', self.eventId)
            .attr('data-orig-result-id', self.originalId)
            .attr('data-result-id', self.actualId);

        self.dom.eventTitle.html(self.eventTitle);
        self.dom.resultTitle.html(self.resultTitle);
        self.dom.coefValue.html(window.Utils.displayCoefValue(self.coefValue));

        self.dom.currencySelect.val(self.currency);

        if ($.fn.niceSelect) {
            self.dom.currencySelect.niceSelect('update');
        }
    };

    StandardCartItem.prototype.loadMaxMoneyValue = function (callback) {
        var self = this;

        Ajax.postJson("/BettingCart/GetMaxMoneyValue", {
            data: {
                coef: {
                    coefid: self.originalId,
                    eventid: self.eventId
                },
                currency: self.currency
            },
            success: function (resp) {
                if (resp.hasOwnProperty('IsUnauthorized')) {
                    if (resp.IsUnauthorized === true) {
                        self.errors.push(window.Localization.getString('BettingCart.LoginToMaxAmount','Пожалуйста, авторизуйтесь для запроса максимальной суммы.'));
                        self.showErrors();

                        return;
                    }
                }

                self.maxMoneyValue = resp;
                if (callback) callback();
            }
        });
    };

    StandardCartItem.prototype.setMaxMoneyValueButtonIsDisabled = function (isDisabled, message) {
        if (isDisabled === true) {
            this.dom.maxMoneyValueBtn.addClass('m-disabled');
            this.dom.maxMoneyValueBtn.addClass('m-disabled').attr('bb-tool', message);
        } else {
            this.dom.maxMoneyValueBtn.removeClass('m-disabled');
            this.dom.maxMoneyValueBtn.removeAttr('bb-tool');
        }
    };

    StandardCartItem.prototype.updateExternalCoef = function (originalId, actualId, value, isActive) {
        if (TableFetcherLive) {
            TableFetcherLive.updateCoef(originalId, actualId, value, isActive);
        }
    };

    StandardCartItem.prototype.loadActualCoefValue = function () {
        var self = this;

        Ajax.postJson("/BettingCart/GetActualCoefs", {
            data: {
                coefs: [
                    {
                        coefid: self.originalId,
                        eventid: self.eventId
                    }
                ]
            },
            success: function (resp) {
                if (Array.isArray(resp)) {
                    for (var i = 0; i < resp.length; i++) {
                        let actual = resp[i];
                        if (parseInt(actual.oid) === parseInt(self.originalId)) {

                            self.updateCoef({
                                actualId: actual.aid,
                                value: actual.val,
                                isActive: actual.act,
                                isLive: actual.il,
                                eventIsActive: actual.ea,
                                eventIsOver: actual.eo,
                                eventId: actual.ei,
                                rTitle: actual.n,
                                homeTeam: actual.ht,
                                awayTeam: actual.at
                            });

                            self.updateExternalCoef(actual.oid, actual.aid, actual.val, actual.act);

                            BettingCart.calc();
                            BettingCart.validate();

                            BettingCart.save();

                            return;
                        }
                    }
                }
            }
        });
    };

    StandardCartItem.prototype.validate = function () {
        var result;

        //if (this.bet < 20 )
        if (this.bet === '' || this.bet <= 0) {
            this.dom.inputWrapper.addClass('error');
            result = false;
        } else {
            this.dom.inputWrapper.removeClass('error');
            result = true;
        }

        return result;
    };

    StandardCartItem.prototype.showErrors = function () {
        var errors = this.errors,
            errorsLength = this.errors.length,
            text = '';

        this.dom.errorsIcon.attr('bb-tool', '');

        for (var i = 0; i < errorsLength; i++) {
            text += errors[i];

            if (i != errorsLength - 1)
                text += '<br />';
        }

        this.dom.errorsIcon
            .attr('bb-tool', text)
            .show();
    };

    StandardCartItem.prototype.hideErrors = function () {
        this.dom.errorsIcon
            .attr('bb-tool', '')
            .hide();
    };

    StandardCartItem.prototype.setIsSelected = function (value) {
        if (value === true) {
            this.isSelected = true;
            this.dom.selectInput.prop('checked', true);
        } else if (value === false) {
            this.isSelected = false;
            this.dom.selectInput.prop('checked', false);
        }

        $(document).trigger('notificationCoefIsSelectedChanged', {
            originalId: this.originalId,
            isSelected: this.isSelected
        });
    };

    StandardCartItem.prototype.updateBonusTooltip = function () {
        var self = this;

        if (self.currency === BettingCart.currencyMap.BONUS && self.bet > 0) {
            self.dom.input.attr('bb-tool', (self.bet / 1000) + ' ' + window.globalAppSettings.currentUser.defaultBalance.currencySymbol);
        } else {
            self.dom.input.removeAttr('bb-tool');
        }
    };

    //-----------Вставка старых функций------------------

    StandardCartItem.prototype.updateCoef = function (data) {
        var self = this;
        var coefIsOverChanged = false;
        let hasChanges = false;

        if (data.hasOwnProperty('isActive') && self.coefIsActive !== data.isActive) {
            self.coefIsActive = data.isActive;
            hasChanges = true;
        }

        //Implement in new cart.addItem
        //if (data.hasOwnProperty('isLive') && self.isLive != data.isLive) {
        //    self.isLive = data.isLive;
        //    hasChanges = true;
        //}

        if (data.hasOwnProperty('isOver') && self.coefIsOver !== data.isOver) {
            self.coefIsOver = data.isOver;
            hasChanges = true;
            coefIsOverChanged = true;
        }
        if (data.hasOwnProperty('eventIsActive') && self.eventIsActive !== data.eventIsActive) {
            self.eventIsActive = data.eventIsActive;
            hasChanges = true;
        }
        if (data.hasOwnProperty('eventIsOver') && self.eventIsOver !== data.eventIsOver) {
            self.eventIsOver = data.eventIsOver;
            hasChanges = true;
            coefIsOverChanged = true;
        }
        if (data.hasOwnProperty('actualId') && self.actualId !== data.actualId) {
            self.actualId = data.actualId;
            hasChanges = true;
        }
        if (data.hasOwnProperty('value') && self.coefValue !== data.value && data.value != 1) {
            var blinkMethod = (self.coefValue > data.value)
                ? function () { self.blinkCoef.decrease.call(self); }
                : function () { self.blinkCoef.increase.call(self); };

            self.coefValue = data.value;
            self.dom.coefValue.html(window.Utils.displayCoefValue(self.coefValue));
            blinkMethod();
            if (StandardCart.getActiveCoefMode().toLowerCase() === 'any')
                self.originalCoefValue = data.value;
            hasChanges = true;
        }

        if (data.hasOwnProperty('eventId') && self.eventId !== data.eventId) {
            self.eventId = data.eventId;
            hasChanges = true;
        }
        if (data.hasOwnProperty('homeTeam')) {
            self.eventTitle = (data.hasOwnProperty('awayTeam')) ? (data.homeTeam + ' — ' + data.awayTeam) : data.homeTeam;
            self.dom.eventTitle.html(self.eventTitle);
        }
        if (data.hasOwnProperty('rTitle')) {
            self.resultTitle = data.rTitle;
            self.dom.resultTitle.html(data.rTitle);
        }


        if (hasChanges) {
            var checkActiveResult = self.checkActive();

            $(document).trigger('notificationCoefInCartUpdate', {
                outcomeId: self.originalId,
                newVal: self.coefValue
            });

            if (coefIsOverChanged) {
                $(document).trigger('coefInBettingCartIsOverChanged', {
                    isOver: checkActiveResult.isOver
                });
            }
        }

        return hasChanges;
    };

    var transitionAddRemoveClass = (function () { //TODO: вынести в utils ?
        var appearVal = 100;
        return function (node, className) {
            node.addClass(className, appearVal);
            node.one('animationend', function (e) {
                node.removeClass(className);
            });
        };
    }());

    StandardCartItem.prototype.blinkCoef = {
        increase: function () {
            transitionAddRemoveClass(this.dom.coefValue, 'change plus');
        },
        decrease: function () {
            transitionAddRemoveClass(this.dom.coefValue, 'change minus');
        }
    };

    StandardCartItem.prototype.setCurrency = function (val) {
        this.currency = val;
    };

    StandardCartItem.prototype.checkActive = function () {
        var self = this;
        var isOver = false;
        var isBlocked = false;

        if (self.coefIsActive && self.eventIsActive && !self.coefIsOver && !self.eventIsOver && self.coefValue != 1) {
            self.dom.container.removeClass('blocked');
            self.dom.container.removeClass('is-over');
            self.dom.coefValue.removeAttr('bb-tool');
        }
        else {
            if (self.coefIsOver || self.eventIsOver) {
                self.dom.container.addClass('is-over');
                self.dom.coefValue.attr('bb-tool', window.Localization.getString('Scripts_Shared_Modules.StandardCartItem_43', 'Прием ставок завершен'));

                isOver = true;
            }
            else {
                self.dom.container.addClass('blocked');
                self.dom.coefValue.attr('bb-tool', window.Localization.getString('Scripts_Shared_Modules.StandardCartItem_44', 'Прием ставок приостановлен'));

                isBlocked = true;
            }
        }

        return {
            isOver: isOver,
            isBlocked: isBlocked
        }
    };

    StandardCartItem.prototype.animateFail = function () {
        var self = this;

        self.dom.container.addClass('error');
        setTimeout(function () {
            self.dom.container.removeClass('error');
        }, 3000);
    };

    StandardCartItem.prototype.animateSuccess = function (removeAfter) {
        var self = this;

        if (self.isSelected === true) {
            self.dom.container.addClass('success');

            setTimeout(function () {
                self.dom.container.removeClass('success');
                if (removeAfter && StandardCart.isTypeSingle())
                    StandardCart.removeItemAfterSend(self.originalId);
            }, 3000);



        }
    };



    //-----------!Вставка старых функций------------------

    StandardCartItem.prototype.bindUI = function () {
        var self = this;

        this.dom.removeBtn.on('click', function () {
            StandardCart.removeItem(self.originalId);
        });

        this.dom.currencySelect.on('change', function () {
            var val = $(this).val();

            document.dispatchEvent(new CustomEvent('mtmCustomEvent', {
                    detail: {
                        id: 'd-i06-e13',
                        value: val,
                    },
                })
            );

            if (val.toLowerCase() !== self.currency.toLowerCase()) {
                self.setCurrency(val);

                // TODO сделать единый конвертер валют
                switch (val) {
                    case 'Bonuses':
                        self.setBet(self.bet * window.globalAppSettings.bonusExchangeRate);
                        break;
                    case 'RUB':
                    case 'KZT':
                        var newVal = self.bet / window.globalAppSettings.bonusExchangeRate;
                        self.setBet(newVal < 1 ? 1 : newVal);
                        break;
                    default:
                        break;
                }

                self.updateDom();

                BettingCart.calc();
                BettingCart.validate();
            }
        });

        this.dom.maxMoneyValueBtn.on('click', function () {
            if (!!!globalAppSettings.currentUser.bettingCart['max-bet-amount-button'].IsEnabled) return;

            self.loadMaxMoneyValue(function () {
                self.setBet(self.maxMoneyValue);
                self.dom.input.val(app.numberToString(self.maxMoneyValue));
            });
        });

        // если выбраны не рубли - не выводим комбобокс
        this.dom.input.on('click', function () {
            if (self.combobox) {
                if (self.currency !== window.globalAppSettings.currentUser.defaultBalance.currencyCode) {
                    self.combobox.preventOpening(true);
                } else {
                    self.combobox.preventOpening(false);
                }
            }
        });

        this.dom.input.on('input change', function (e) {
            var filteredVal = $(this).val().replace(/\D/g, '');
            $(this).val((parseInt(filteredVal) === 0 || !filteredVal) ? '' : app.numberToString(filteredVal));

            self.setBet(filteredVal);
        });

        this.dom.selectInput.on('change', function () {
            self.setIsSelected($(this).prop('checked'));
            BettingCart.calc();
            BettingCart.validate();
        });

        this.dom.input.on('mouseenter', function () {
            var elem = $(this);

            if (self.currency !== 'RUB') {
                self.updateBonusTooltip();
            } else if (elem.attr('bb-tool')) {
                elem.removeAttr('bb-tool');
            }
        });
    };

    return StandardCartItem;
}());